import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#24325E",
    },
    black: {
      main: "#000000",
      light: "#a2a2a2",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#2d2d2d",
      light: "#a2a2a2",
    },
  },
});

export default theme;
